import React from "react";
import { Projects } from "../components/Sections/projects/Projects";

const ProjectsPage: React.FC = () => {
  return <Projects showAll />;
};

export default ProjectsPage;
